import type {Root as MarkdownRoot} from 'mdast'
import {fromMarkdown} from 'mdast-util-from-markdown'
import {gfmFromMarkdown as mdastGfm} from 'mdast-util-gfm'
import {gfm as micromarkGfm} from 'micromark-extension-gfm'

import {mdastDelimiters} from './extensions/delimiters'
import {mdastEnrichTables} from './extensions/enrich-tables'
import {mdastExpandNestedBlockquotes} from './extensions/expand-nested-blockquotes'

export function parseMarkdown(markdown: string): MarkdownRoot {
  return fromMarkdown(markdown, 'utf-8', {
    extensions: [micromarkGfm()],
    mdastExtensions: [mdastGfm(), mdastDelimiters(), mdastExpandNestedBlockquotes(), mdastEnrichTables()],
  })
}
